<!-- <p>drawer works!</p> -->
<mat-drawer-container class="drawer-container">

    <mat-drawer #drawer mode="over" position="end" class="drawer" [style.width]="drawerService.width()">

        <div class="drawer-header">

            <div class="drawer-title">

                <div class="drawer-icon">
                    ✨
                </div>

                <div>

                    <h4>{{ drawerService.title() }}</h4>

                    <div class="drawer-subtitle">
                        {{ drawerService.subTitle() }}
                    </div>

                </div>

            </div>

            <button mat-icon-button class="close-btn" (click)="drawer.close()">
                <mat-icon>close</mat-icon>
            </button>

        </div>

        <div class="drawer-body">

            <ng-container *ngTemplateOutlet="drawerService.content()">
            </ng-container>

        </div>

    </mat-drawer>

    <mat-drawer-content>

        <ng-content></ng-content>

    </mat-drawer-content>

</mat-drawer-container>